import { useSyncExternalStore } from "react";

export const SESSION_CHANGED = "bds-session-changed";
export const getSessionToken = () => localStorage.getItem("session_token");
export const setSessionToken = (token) => {
  localStorage.setItem("session_token", token);
  window.dispatchEvent(new Event(SESSION_CHANGED));
};
export const clearSessionToken = () => {
  localStorage.removeItem("session_token");
  window.dispatchEvent(new Event(SESSION_CHANGED));
};
const subscribe = (listener) => {
  const storage = (event) => { if (event.key === "session_token" || event.key === null) listener(); };
  window.addEventListener(SESSION_CHANGED, listener);
  window.addEventListener("storage", storage);
  window.addEventListener("focus", listener);
  return () => {
    window.removeEventListener(SESSION_CHANGED, listener);
    window.removeEventListener("storage", storage);
    window.removeEventListener("focus", listener);
  };
};
export const useSessionToken = () => useSyncExternalStore(subscribe, getSessionToken, () => null);